import { Routes, Route } from 'react-router-dom';
import { useTheme } from "./theming/default_theme";
import Login from "./Pages/Login/Login";
import LandingPage from "./Pages/Landingpage";
import Referrals from "./Pages/Referrals";
import ReferralDetails from "./Pages/ReferralDetails";
import HospitalDetailsPage from "./Pages/HospitalDetailsPage";
import VisionAmbassadorDetailsPage from "./Pages/VisionAmbassadorDetails";
import ProtectedRoute from "./Pages/ProtectedRoute";
import DeleteUserAccount from './Pages/DeleteUserAccount';

const App = () => {
  const theme = useTheme();
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/delete-account" element={<DeleteUserAccount />} />
        <Route
          path="/Landingpage"
          element={
            <ProtectedRoute>
              <LandingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/referrals"
          element={
            <ProtectedRoute>
              <Referrals
                showModal={false}
                setShowModal={function (value: boolean): void {
                  throw new Error("Function not implemented.");
                }}
                menuSelected={""}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/referrals/:id"
          element={
            <ProtectedRoute>
              <ReferralDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Landingpage/HospitalDetails/:hospitalId"
          element={
            <ProtectedRoute>
              <HospitalDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/LandingPage/VisionAmbassadorDetailsPage/:ambassadorId"
          element={
            <ProtectedRoute>
              <VisionAmbassadorDetailsPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
};

export default App;